/* unplugin-vue-components disabled */import script from "./Chargedetails.vue?vue&type=script&setup=true&name=Chargedetails&lang=js"
export * from "./Chargedetails.vue?vue&type=script&setup=true&name=Chargedetails&lang=js"

import "./Chargedetails.vue?vue&type=style&index=0&id=ae1f8b98&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae1f8b98"]])

export default __exports__